import React, { useState } from 'react';
import { MapPin, X, Tag, PlusCircle, Search } from 'lucide-react';

/**
 * Lista todas as áreas cadastradas como cards clicáveis.
 * Cada card mostra nome, descrição curta e palavras-chave.
 * Clicar abre o AreaDetailModal.
 */
const AreasListModal = ({ areas, onClose, onOpenArea, onNewArea }) => {
  const [search, setSearch] = useState('');

  const filtered = (areas || []).filter(a => {
    const q = search.toLowerCase();
    if (!q) return true;
    return (
      (a.nome || '').toLowerCase().includes(q) ||
      (a.descricao || '').toLowerCase().includes(q) ||
      (a.palavras_chave || []).some(p => p.toLowerCase().includes(q))
    );
  });

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[10000] p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-[95vw] 2xl:max-w-7xl max-h-[95vh] flex flex-col">

        <div className="p-5 border-b border-slate-200 flex items-center justify-between flex-shrink-0">
          <h2 className="text-lg font-semibold text-slate-800 flex items-center gap-2">
            <MapPin className="text-purple-600" size={20} />
            Gerenciar Áreas
            <span className="text-sm font-normal text-slate-500">({areas?.length || 0})</span>
          </h2>
          <div className="flex items-center gap-2">
            <button
              onClick={onNewArea}
              className="px-3 py-1.5 bg-purple-600 text-white rounded-md hover:bg-purple-700 text-sm flex items-center gap-1"
            >
              <PlusCircle size={14} /> Nova Área
            </button>
            <button onClick={onClose} className="text-slate-400 hover:text-slate-600">
              <X size={22} />
            </button>
          </div>
        </div>

        {/* Busca */}
        <div className="px-5 py-3 border-b border-slate-100 flex-shrink-0">
          <div className="relative">
            <Search size={14} className="absolute left-2.5 top-2.5 text-slate-400" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-8 pr-3 py-1.5 border border-slate-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Buscar por nome, descrição ou palavra-chave..."
            />
          </div>
        </div>

        {/* Lista */}
        <div className="flex-grow overflow-y-auto p-4">
          {filtered.length === 0 ? (
            <div className="text-center py-10 text-sm text-slate-500">
              {search ? 'Nenhuma área encontrada com esse filtro.' : 'Nenhuma área cadastrada ainda.'}
            </div>
          ) : (
            <div className="space-y-2">
              {filtered.map(area => {
                const palavras = area.palavras_chave || [];
                return (
                  <button
                    key={area.id}
                    onClick={() => onOpenArea(area)}
                    className="w-full text-left bg-white border border-slate-200 rounded-md p-3 hover:border-purple-400 hover:shadow-sm transition-all"
                  >
                    <div className="flex items-start gap-3">
                      <div className="bg-purple-50 p-1.5 rounded flex-shrink-0">
                        <MapPin size={16} className="text-purple-600" />
                      </div>
                      <div className="flex-grow min-w-0">
                        <div className="font-medium text-sm text-slate-800 truncate">
                          {area.nome}
                        </div>
                        {area.descricao && (
                          <div className="text-xs text-slate-500 mt-0.5 line-clamp-1">
                            {area.descricao}
                          </div>
                        )}
                        {palavras.length > 0 && (
                          <div className="flex flex-wrap gap-1 mt-1.5">
                            <Tag size={10} className="text-slate-400 mt-0.5" />
                            {palavras.slice(0, 5).map((p, i) => (
                              <span key={i} className="text-[10px] px-1.5 py-0.5 rounded bg-purple-50 text-purple-700">
                                {p}
                              </span>
                            ))}
                            {palavras.length > 5 && (
                              <span className="text-[10px] text-slate-400">+{palavras.length - 5}</span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </div>

        <div className="p-3 border-t border-slate-200 bg-slate-50 flex-shrink-0 text-center">
          <span className="text-[11px] text-slate-500">
            Clique numa área para ver detalhes e detectar ofertas nos emails
          </span>
        </div>
      </div>
    </div>
  );
};

export default AreasListModal;
